/**
 * AP Invoices Demo — demo-only AP workflow build canvas route.
 *
 * THROWAWAY DEMO CODE. Registers `/demo/ap/workflow` so the "make me an AP
 * processing workflow" chat tool can navigate to the build canvas. Wired into
 * the route tree from frontend/src/routes.tsx (one import + one tree entry). No
 * permission/module gating — it only renders demo fixture state and is gated by
 * demo mode in practice. Delete with src/demo/ap.
 */

import { createRoute } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '@/pages/authenticated/route';
import paths from '@/paths';
import { ApWorkflowBuildPage } from './ApWorkflowBuildPage';
import { ApWorkflowAgentModule } from './ApWorkflowAgentModule';

// Mount the agent module here (not inside the page) so Nami stays registered
// across the empty → built canvas swap — otherwise the remount would briefly
// clear the module and close the chat panel mid-build.
function ApWorkflowRoute() {
  return (
    <>
      <ApWorkflowAgentModule />
      <ApWorkflowBuildPage />
    </>
  );
}

export const Route = createRoute({
  path: paths.authenticated.demoApWorkflow,
  getParentRoute: () => pathlessAuthenticatedRoute,
  component: ApWorkflowRoute,
  loader: () => ({ crumb: 'AP Demo Workflow' }),
});
